import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-title" className="w-full bg-cream-50 px-5 py-20 sm:py-24" data-id="element-42" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-3xl" data-id="element-43" data-mp="1geikw9y8akxn">
        <h2 id="faq-title" className="text-center font-display text-4xl font-semibold leading-tight tracking-tight text-plum-800 sm:text-left sm:text-5xl" data-id="element-44" data-mp="2e06aaaw9o2zo">
          Preguntas frecuentes
        </h2>

        <div className="mt-10 divide-y divide-cream-300 border-y border-cream-300" data-id="element-45" data-mp="2418imz3jntcg">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} data-id="element-46" data-mp="so63m8h3fbue" data-mpi={index}>
                <h3 data-id="element-47" data-mp="sl0ggys0yk1b">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-6 py-5 text-left text-base font-medium text-plum-800 outline-none transition-colors duration-150 hover:text-rose-600 focus-visible:text-rose-600" data-id="element-48" data-mp="no0cquindtdd">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-rose-500 transition-transform duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-45' : ''}`} data-id="element-49" data-mp="6qwt05dnwtxo" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="1smy7vvunvcl">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="3jz9q7q1z9gnr">
                      <p className="pb-6 pr-10 text-base leading-relaxed text-plum-500" data-id="element-52" data-mp="1krkrg7mbccy8">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}